import reportTypes from './reportTypes';
import utils from 'utils';
import commonStrings from 'resources/commonStrings';
import { addDays, format } from 'date-fns';

const transformReportType = (reportType) => {
  const reportTypeObject = reportTypes[reportType];
  return reportTypeObject ? reportTypeObject.displayName : reportType;
};

const parseDeleteDate = (creationDate) => {
  return format(addDays(new Date(creationDate), 14), 'MM/dd/yy');
};

const transformReportFileSize = (reportFileSize) => {
  return reportFileSize ? utils.getReadableFileSizeString(reportFileSize) : reportFileSize;
};

const statusMap = {
  IN_PROGRESS: {
    displayName: commonStrings.queueStatus.processing,
  },
  SUBMITTED: {
    displayName: commonStrings.queueStatus.processing,
  },
  COMPLETE: {
    displayName: commonStrings.queueStatus.readyToView,
  },
  SUCCESS: {
    displayName: commonStrings.queueStatus.readyToView,
  },
  FAILED: {
    displayName: commonStrings.queueStatus.failed,
  },
  FAILURE: {
    displayName: commonStrings.queueStatus.failed,
  },
};

const transformStatus = (status) => {
  const transformedStatus = statusMap[status];
  return transformedStatus ? transformedStatus.displayName : status;
};

export default {
  parseDeleteDate,
  transformReportType,
  transformStatus,
  transformReportFileSize,
};
